import { debounce } from "lodash";
import moment from "moment";
import * as React from "react";
import { FC, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { Form, actions } from "react-redux-form";
import { useParams } from "react-router";
import Alert from "react-s-alert";
import ReactTable, { RowInfo } from "react-table";
import { bindActionCreators } from "redux";
import * as NavigationActions from "../../../actions/navigation";
import * as PagingActions from "../../../actions/pages/pagingPage";
import * as PersonnelActions from "../../../actions/personnel";
import * as PersonnelTrainingActions from "../../../actions/personnelTraining";
import { NotificationAlert } from "../../../components/common/index";
import {
    DatePickerFormInputFabric,
    TextFormInput,
    ValidationMessage,
} from "../../../components/form/index";
import { SOURCE_DOCUMENT_UPLOAD_VIEW } from "../../../components/form/inputs/FileUploadFormInput/FileUploadViews";
import { FileUploadFormInput } from "../../../components/form/inputs/FileUploadFormInput/index";
import {
    RestrictedLayout,
    TruncatedCell,
} from "../../../components/layouts/index";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../constants/fontAwesomeIcons";
import { PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { DocumentType } from "../../../enumerations/DocumentType";
import { GridRemove } from "../../../enumerations/GridRemove";
import { RequestState } from "../../../enumerations/RequestState";
import { renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import { PersonnelTrainingBreadcrumbs } from "../../../helpers/breadcrumbHelper";
import { SOURCE_DOCUMENT_FILE_CONFIGURATION } from "../../../helpers/file";
import {
    RegistrationComponent,
    getFormPropertyLabel,
    renderFormControls,
} from "../../../helpers/formHelper";
import { PersonnelSubMenu } from "../../../helpers/subMenuHelper";
import useNavigate from "../../../hooks/useNavigate";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import { IPersonnelReduxFormState } from "../../../reducers/reactReduxForms/personnel";
import { initialSourceDocumentState } from "../../../reducers/reactReduxForms/sourceDocument";
import {
    requiredSourceDocument,
    requiredText,
} from "../../../validators/index";
import PersonnelTrainingFormModal from "./PersonnelTrainingFormModal";

import "./PersonnelTrainingCertificationPage.scss";

interface PersonnelTrainingCertificationPageProps {
    form: Dtos.Personnel & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: IPersonnelReduxFormState;
    personnel: Dtos.Personnel;
    lookups: Dtos.Lookup[];
    loadingPersonnel: boolean;
    loadPersonnelSuccess: boolean;
    loadPersonnelFailure: boolean;
    loadPersonnelErrorCode: string;
    savingPersonnel: boolean;
    savePersonnelSuccess: boolean;
    savePersonnelFailure: boolean;
    validatingPersonnel: boolean;
    validationFailures: Dtos.ResponseError[];
    personnelTraining: Dtos.PersonnelTraining[];
    loadingPersonnelTraining: boolean;
    loadPersonnelTrainingSuccess: boolean;
    loadPersonnelTrainingFailure: boolean;
    loadPersonnelTrainingErrorCode: string;
    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    pageSize: number;
    clearPersonnel: PersonnelActions.IPersonnelClearActionCreator;
    loadPersonnel: PersonnelActions.IPersonnelLoadByIdActionCreator;
    savePersonnel: PersonnelActions.IPersonnelSaveActionCreator;
    validatePersonnel: PersonnelActions.IPersonnelValidateActionCreator;
    clearPersonnelTraining: PersonnelTrainingActions.IPersonnelTrainingClearActionCreator;
    loadPersonnelTraining: PersonnelTrainingActions.IPersonnelTrainingLoadByPersonnelIdActionCreator;
    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;
    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;
    setPageSize: PagingActions.IPagingPageSizeChangedStateActionCreator;
}

const reduxFormName: string = "reduxForms.personnel";

const PersonnelTrainingCertificationPage: FC<PersonnelTrainingCertificationPageProps> = ({
    form,
    formState,
    formProperties,
    //reduxFormState,
    personnel,
    lookups,
    loadingPersonnel,
    //loadPersonnelSuccess,
    loadPersonnelFailure,
    loadPersonnelErrorCode,
    savingPersonnel,
    savePersonnelSuccess,
    savePersonnelFailure,
    validatingPersonnel,
    validationFailures,
    personnelTraining,
    //loadingPersonnelTraining,
    //loadPersonnelTrainingSuccess,
    loadPersonnelTrainingFailure,
    loadPersonnelTrainingErrorCode,
    //user,
    permissions,
    pageSize,
    clearPersonnel,
    loadPersonnel,
    savePersonnel,
    validatePersonnel,
    clearPersonnelTraining,
    loadPersonnelTraining,
    loadForm,
    changeForm,
    resetForm,
    setBreadcrumbs,
    setDrawerItems,
    setPageSize
}) => {
    //
    // -- Params --
    const { personnelId } = useParams<{ personnelId: string }>();
    const personnelIdNumber = parseInt(personnelId, 10);

    //
    // -- Hooks --
    const navigate = useNavigate();

    //
    // -- States --
    const [saveAndReturn, setSaveAndReturn] = useState<boolean>(false);
    const [initalised, setInitalised] = useState<boolean>(false);
    const [hasBeenSubmitted, setHasBeenSubmitted] = useState<boolean>(false);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [personnelTrainingId, setPersonnelTrainingId] = useState<number | null>(null);

    const loadReduxForm = () => {
        let extraData: Dtos.Personnel = {} as Dtos.Personnel;

        loadForm(reduxFormName, Object.assign({ ...personnel }, extraData));
    };


    // Load personnel
    useEffect(() => {
        if (personnelIdNumber && !personnel && !loadingPersonnel) {
            setDrawerItems(PersonnelSubMenu(personnelIdNumber, permissions));
            setBreadcrumbs(PersonnelTrainingBreadcrumbs(personnelIdNumber));
            loadPersonnel(personnelIdNumber);
            loadPersonnelTraining(personnelIdNumber);
        } else if (personnel && !initalised) {
            loadReduxForm();
            setInitalised(true);
        }
    }, [
        personnelIdNumber,
        personnel,
        setDrawerItems,
        PersonnelSubMenu,
        permissions,
        setBreadcrumbs,
        PersonnelTrainingBreadcrumbs,
        loadPersonnel,
        initalised,
        setInitalised,
        loadReduxForm,
        loadingPersonnel,
        loadPersonnelTraining,
    ]);

    // Navigate to error page on load failure
    useEffect(() => {
        if (loadPersonnelFailure) {
            navigate(`/error/${loadPersonnelErrorCode}`);
        }
        if (loadPersonnelTrainingFailure) {
            navigate(`/error/${loadPersonnelTrainingErrorCode}`);
        }
    }, [
        loadPersonnelFailure, 
        loadPersonnelErrorCode, 
        loadPersonnelTrainingFailure, 
        loadPersonnelTrainingErrorCode, 
        navigate
    ]);

    // Update breadcrumbs
    useEffect(() => {
        if (personnelIdNumber && personnel) {
            setBreadcrumbs(
                PersonnelTrainingBreadcrumbs(
                    personnelIdNumber,
                    `${personnel.firstName} ${personnel.lastName}`
                )
            );
        }
    }, [
        personnelIdNumber,
        personnel,
        setBreadcrumbs,
        PersonnelTrainingBreadcrumbs,
    ]);

    // Reload personnel after saving
    useEffect(() => {
        if (!savingPersonnel && savePersonnelSuccess) {
            Alert.success(
                <NotificationAlert
                    alertContent={<span>Personnel saved successfully</span>}
                    icon={FontAwesomeIcons.Solid.CHECK}
                />
            );

            if (saveAndReturn) {
                navigate("/personnel");
            } else if (!personnelIdNumber) {
                navigate(`/personnel/${personnel?.id}/trainingcertifications`);
            }
        }
    }, [
        savingPersonnel,
        savePersonnelSuccess
    ]);

    // Failed saving
    useEffect(() => {
        if (!savingPersonnel && savePersonnelFailure) {
            Alert.error(
                <NotificationAlert
                    alertContent={renderRegistrationFormSaveBlock()}
                    icon={FontAwesomeIcons.Solid.BAN}
                />
            );
        }
    }, [savingPersonnel, savePersonnelFailure]);

    // Cleanup effect to clear the trial on component unmount
    useEffect(() => {
        return () => {
            clearPersonnel();
            clearPersonnelTraining();
            resetForm(reduxFormName);
        };
    }, [clearPersonnel, clearPersonnelTraining, resetForm, reduxFormName]);

    // Clear training id on modal close
    useEffect(() => {
        if (!isOpen) {
            setPersonnelTrainingId(null);
        }
    }, [isOpen, setPersonnelTrainingId]);

    const onCancel = () => {
        navigate("/personnel");
    };

    const handleOnSubmitFailed = (_data: Dtos.Personnel) => {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    };

    const handleOnSubmit = async (data: any) => {
        if (!hasBeenSubmitted) {
            setHasBeenSubmitted(true);
        }

        if (data) {
            let changes: Dtos.Personnel = {
                trainingAndCertifications: true,
            } as Dtos.Personnel;

            await savePersonnel(Object.assign({ ...data }, changes));

            if (data.saveAndReturn) {
                setSaveAndReturn(true);
            }
        }
    };

    // Debounce validation after the initial submit to clear form validation errors as the form get updated.
    useEffect(() => {
        const debounceValidate = debounce(async () => {
            let changes: Dtos.Personnel = {} as Dtos.Personnel;

            if (form && hasBeenSubmitted && !validatingPersonnel) {
                await validatePersonnel(Object.assign({ ...form }, changes));
            }
        }, 250);

        debounceValidate();

        return () => {
            debounceValidate.cancel();
        };
    }, [form]);

    const renderTrainingTable = useMemo(() => {
        if (personnelTraining?.length == 0) {
            return (
                <div className="card card-shadow p-3">
                    <div className="alert alert-info d-flex mb-0">
                        <div className="mr-2">
                            <FontAwesomeIcon
                                icon={FontAwesomeIcons.Solid.INFO_SQUARE}
                                fixedWidth
                            />
                        </div>
                        <span>
                            {personnel?.displayWithSalutation} has not completed any training.
                        </span>
                    </div>
                </div>
            );
        }

        const showPagination = personnelTraining?.length > pageSize;

        return (
            <div className="card card-shadow">
                <div className="table-wrapper">
                    <ReactTable
                        data={personnelTraining}
                        pageSizeOptions={PAGE_SIZE_OPTIONS}
                        defaultPageSize={
                            showPagination
                                ? pageSize
                                : personnelTraining?.length
                        }
                        pageSize={
                            showPagination
                                ? pageSize
                                : personnelTraining?.length
                        }
                        showPagination={showPagination}
                        className="-striped -highlight -clickable"
                        noDataText="There are currently no training to display"
                        resizable={false}
                        onPageSizeChange={(val) => setPageSize(val)}
                        getTdProps={(
                            _state,
                            rowInfo: RowInfo,
                            _column,
                            _instance
                        ) => {
                            return {
                                onClick: (_e, handleOriginal) => {
                                    setPersonnelTrainingId(rowInfo.original.id);
                                    setIsOpen(true);

                                    if (handleOriginal) {
                                        handleOriginal();
                                    }
                                },
                            };
                        }}
                        defaultSorted={[
                            {
                                id: "dateEntered",
                                desc: true,
                            },
                        ]}
                        columns={[
                            {
                                id: "id",
                                Header: " ",
                                accessor: "id",
                                maxWidth: 50,
                                Cell: (_props) => (
                                    <FontAwesomeIcon size="lg" icon={FontAwesomeIcons.Duotone.FILECERTIFICATE} fixedWidth />
                                ),
                            },
                            {
                                id: "trainingType",
                                Header: "Type",
                                accessor: "trainingType.value",
                            },
                            {
                                id: "courseModule",
                                Header: "Course Module",
                                accessor: "courseModule",
                                Cell: (props) =>
                                    props.value ? (
                                        <TruncatedCell value={props.value} />
                                    ) : (
                                        <TruncatedCell value={props?.original?.trainingGeneralSystemType?.value} />
                                    ),
                            },
                            {
                                id: "dateCompleted",
                                Header: "Date Completed",
                                accessor: "dateCompleted",
                                Cell: (props) => (
                                    <span>
                                        {moment(props.value ?? props?.original?.dateCompleted, "YYYY-MM-DD HH:mm:ss.SSSSSSS Z").format("DD/MM/YYYY")}
                                    </span>
                                ),
                            },
                        ]}
                    />
                </div>
            </div>
        );
    }, [
        personnel,
        personnelTraining,
        pageSize,
        PAGE_SIZE_OPTIONS,
        setPageSize,
        setPersonnelTrainingId,
        setIsOpen,
    ]);

    const renderContent = useMemo(() => {
        const hasPermission: boolean =
            AuthenticationHelper.hasCreateEditPermission(
                form,
                permissions,
                Dtos.Permission.TrainingCertificationsUpdate,
                Dtos.Permission.TrainingCertificationsCreate
            );
        const formDisabled: boolean =
            !hasPermission ||
            savingPersonnel ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            pmbApprovalGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <h1>PMB Approval</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-xl-12 col-xxl-6">
                                    {renderFormControls(
                                        form,
                                        "personnel",
                                        {
                                            pmbApprovalNCIInvestigatorNo: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-12 col-lg-3",
                                                fieldClassName:
                                                    "col-sm-12 col-lg-9 col-xxl-8 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-xl-12 col-xxl-6">
                                    {renderFormControls(
                                        form,
                                        "personnel",
                                        {
                                            pmbApprovalDateOfNCIExpiry: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType:
                                                    DatePickerFormInputFabric,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-12 col-lg-3",
                                                fieldClassName:
                                                    "col-sm-12 col-lg-9 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "personnel",
                                        {
                                            pmbPacketDocuments: {
                                                size: 1,
                                                type: RegistrationComponent.RegistrationSourceDocuments,
                                                label: "PMB packets",
                                                disabled: formDisabled,
                                                components: {
                                                    sourceDocuments: {
                                                        type: RegistrationComponent.RegistrationGrid,
                                                        formName:
                                                            "SourceDocument",
                                                        disabled: formDisabled,
                                                        label: "Add Source Document",
                                                        className:
                                                            "source-documents-source-documents",
                                                        minRows: 0,
                                                        columnStyles: [
                                                            {
                                                                width: undefined,
                                                                minWidth:
                                                                    "200px",
                                                            },
                                                            {
                                                                width: "23%",
                                                                minWidth:
                                                                    "150px",
                                                            },
                                                            {
                                                                width: "20%",
                                                                minWidth:
                                                                    "150px",
                                                            },
                                                            {
                                                                width: "125px",
                                                            },
                                                        ],
                                                        removeConfig:
                                                            GridRemove.All,
                                                        addRow: (gridComponent, _index, _array) => {
                                                            const state: Dtos.SourceDocument =
                                                                Object.assign({
                                                                    ...gridComponent.initialState,
                                                                });
                                                            state.subRecordId =
                                                                DocumentType.PMBPacket;
                                                            return state;
                                                        },
                                                        components: {
                                                            name: {
                                                                type: RegistrationComponent.RegistrationControl,
                                                                inputType:
                                                                    TextFormInput,
                                                                inputDisabled:
                                                                    formDisabled,
                                                                inputLabel:
                                                                    getFormPropertyLabel(
                                                                        "CollectionInstance",
                                                                        "FileName",
                                                                        formProperties
                                                                    ),
                                                                inputProps: {
                                                                    feedbackIcon:
                                                                        FontAwesomeIcons
                                                                            .Solid
                                                                            .BAN,
                                                                },
                                                                validators: {
                                                                    required:
                                                                        requiredText,
                                                                },
                                                                errors: {
                                                                    required:
                                                                        "File name is required.",
                                                                },
                                                                errorComponent:
                                                                    ValidationMessage,
                                                            },
                                                            fileInformation: {
                                                                type: RegistrationComponent.RegistrationControl,
                                                                inputType:
                                                                    FileUploadFormInput,
                                                                inputDisabled:
                                                                    formDisabled,
                                                                inputLabel:
                                                                    getFormPropertyLabel(
                                                                        "CollectionInstance",
                                                                        "Upload",
                                                                        formProperties
                                                                    ),
                                                                changeAction: (
                                                                    model,
                                                                    value,
                                                                    form,
                                                                    parentModel
                                                                ) => {
                                                                    changeForm(
                                                                        model,
                                                                        value
                                                                    );
                                                                    const inputValue: Dtos.TemporaryFileInformation =
                                                                        value;
                                                                    const sourceDocument: Dtos.SourceDocument =
                                                                        form;

                                                                    if (
                                                                        sourceDocument.fileInformation &&
                                                                        inputValue &&
                                                                        sourceDocument
                                                                            .fileInformation
                                                                            .state !=
                                                                            inputValue.state &&
                                                                        inputValue.state ==
                                                                            Dtos
                                                                                .FileState
                                                                                .Success &&
                                                                        !sourceDocument.name
                                                                    ) {
                                                                        changeForm(
                                                                            reduxFormName +
                                                                                parentModel +
                                                                                ".name",
                                                                            inputValue.temporaryFile.name.substr(
                                                                                0,
                                                                                inputValue.temporaryFile.name.lastIndexOf(
                                                                                    inputValue
                                                                                        .temporaryFile
                                                                                        .extension
                                                                                )
                                                                            )
                                                                        );
                                                                    }
                                                                },
                                                                inputProps: {
                                                                    render: SOURCE_DOCUMENT_UPLOAD_VIEW,
                                                                },
                                                                validators: {
                                                                    required:
                                                                        requiredSourceDocument,
                                                                },
                                                                errors: {
                                                                    required:
                                                                        "File must be uploaded.",
                                                                },
                                                                errorComponent:
                                                                    ValidationMessage,
                                                            },
                                                            fileConfiguration: {
                                                                type: RegistrationComponent.RegistrationGridElement,
                                                                label: " ",
                                                                render: SOURCE_DOCUMENT_FILE_CONFIGURATION,
                                                            },
                                                        },
                                                        initialState: {
                                                            ...initialSourceDocumentState,
                                                        },
                                                    },
                                                },
                                                keyReplace: "sourceDocuments",
                                                onRemove: (model: string) => {
                                                    if (
                                                        AuthenticationHelper.hasPermission(
                                                            permissions,
                                                            Dtos.Permission
                                                                .TrainingCertificationsUpdate
                                                        )
                                                    ) {
                                                        changeForm(
                                                            model + "active",
                                                            false
                                                        );
                                                    }
                                                    return true; // this was handled here
                                                },
                                                filterRow: (
                                                    data: Dtos.SourceDocument
                                                ) => {
                                                    return (
                                                        !data.isPersonnelItem &&
                                                        data.active &&
                                                        data.subRecordId ==
                                                            DocumentType.PMBPacket
                                                    );
                                                },
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            medicalRegistrationGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>Medical Registration</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "personnel",
                                        {
                                            medicalRegistrationExpiryDate: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType:
                                                    DatePickerFormInputFabric,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-1",
                                                fieldClassName:
                                                    "col-11 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "personnel",
                                        {
                                            practitionerRegistrationDocument: {
                                                size: 1,
                                                type: RegistrationComponent.RegistrationSourceDocuments,
                                                label: "Practitioner Registration",
                                                disabled: formDisabled,
                                                components: {
                                                    sourceDocuments: {
                                                        type: RegistrationComponent.RegistrationGrid,
                                                        formName:
                                                            "SourceDocument",
                                                        disabled: formDisabled,
                                                        label: "Add Source Document",
                                                        className:
                                                            "source-documents-source-documents",
                                                        minRows: 0,
                                                        columnStyles: [
                                                            {
                                                                width: undefined,
                                                                minWidth:
                                                                    "200px",
                                                            },
                                                            {
                                                                width: "23%",
                                                                minWidth:
                                                                    "150px",
                                                            },
                                                            {
                                                                width: "20%",
                                                                minWidth:
                                                                    "150px",
                                                            },
                                                            {
                                                                width: "125px",
                                                            },
                                                        ],
                                                        removeConfig:
                                                            GridRemove.All,
                                                        addRow: (gridComponent, _index, _array) => {
                                                            const state: Dtos.SourceDocument =
                                                                Object.assign({
                                                                    ...gridComponent.initialState,
                                                                });
                                                            state.subRecordId =
                                                                DocumentType.MedicalPractitionerRegistration;
                                                            return state;
                                                        },
                                                        components: {
                                                            name: {
                                                                type: RegistrationComponent.RegistrationControl,
                                                                inputType:
                                                                    TextFormInput,
                                                                inputDisabled:
                                                                    formDisabled,
                                                                inputLabel:
                                                                    getFormPropertyLabel(
                                                                        "CollectionInstance",
                                                                        "FileName",
                                                                        formProperties
                                                                    ),
                                                                inputProps: {
                                                                    feedbackIcon:
                                                                        FontAwesomeIcons
                                                                            .Solid
                                                                            .BAN,
                                                                },
                                                                validators: {
                                                                    required:
                                                                        requiredText,
                                                                },
                                                                errors: {
                                                                    required:
                                                                        "File name is required.",
                                                                },
                                                                errorComponent:
                                                                    ValidationMessage,
                                                            },
                                                            fileInformation: {
                                                                type: RegistrationComponent.RegistrationControl,
                                                                inputType:
                                                                    FileUploadFormInput,
                                                                inputDisabled:
                                                                    formDisabled,
                                                                inputLabel:
                                                                    getFormPropertyLabel(
                                                                        "CollectionInstance",
                                                                        "Upload",
                                                                        formProperties
                                                                    ),
                                                                changeAction: (
                                                                    model,
                                                                    value,
                                                                    form,
                                                                    parentModel
                                                                ) => {
                                                                    changeForm(
                                                                        model,
                                                                        value
                                                                    );
                                                                    const inputValue: Dtos.TemporaryFileInformation =
                                                                        value;
                                                                    const sourceDocument: Dtos.SourceDocument =
                                                                        form;

                                                                    if (
                                                                        sourceDocument.fileInformation &&
                                                                        inputValue &&
                                                                        sourceDocument
                                                                            .fileInformation
                                                                            .state !=
                                                                            inputValue.state &&
                                                                        inputValue.state ==
                                                                            Dtos
                                                                                .FileState
                                                                                .Success &&
                                                                        !sourceDocument.name
                                                                    ) {
                                                                        changeForm(
                                                                            reduxFormName +
                                                                                parentModel +
                                                                                ".name",
                                                                            inputValue.temporaryFile.name.substr(
                                                                                0,
                                                                                inputValue.temporaryFile.name.lastIndexOf(
                                                                                    inputValue
                                                                                        .temporaryFile
                                                                                        .extension
                                                                                )
                                                                            )
                                                                        );
                                                                    }
                                                                },
                                                                inputProps: {
                                                                    render: SOURCE_DOCUMENT_UPLOAD_VIEW,
                                                                },
                                                                validators: {
                                                                    required:
                                                                        requiredSourceDocument,
                                                                },
                                                                errors: {
                                                                    required:
                                                                        "File must be uploaded.",
                                                                },
                                                                errorComponent:
                                                                    ValidationMessage,
                                                            },
                                                            fileConfiguration: {
                                                                type: RegistrationComponent.RegistrationGridElement,
                                                                label: " ",
                                                                render: SOURCE_DOCUMENT_FILE_CONFIGURATION,
                                                            },
                                                        },
                                                        initialState: {
                                                            ...initialSourceDocumentState,
                                                        },
                                                    },
                                                },
                                                keyReplace: "sourceDocuments",
                                                onRemove: (model: string) => {
                                                    if (
                                                        AuthenticationHelper.hasPermission(
                                                            permissions,
                                                            Dtos.Permission
                                                                .TrainingCertificationsUpdate
                                                        )
                                                    ) {
                                                        changeForm(
                                                            model + "active",
                                                            false
                                                        );
                                                    }
                                                    return true; // this was handled here
                                                },
                                                filterRow: (
                                                    data: Dtos.SourceDocument
                                                ) => {
                                                    return (
                                                        !data.isPersonnelItem &&
                                                        data.active &&
                                                        data.subRecordId ==
                                                            DocumentType.MedicalPractitionerRegistration
                                                    );
                                                },
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            medicalIndemnityGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>Medical Indemnity for Clinical Trials</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "personnel",
                                        {
                                            medicalIndemnityExpiryDate: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType:
                                                    DatePickerFormInputFabric,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-1",
                                                fieldClassName:
                                                    "col-11 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "personnel",
                                        {
                                            practitionerRegistrationDocument: {
                                                size: 1,
                                                type: RegistrationComponent.RegistrationSourceDocuments,
                                                label: "Professional Indemnity",
                                                disabled: formDisabled,
                                                components: {
                                                    sourceDocuments: {
                                                        type: RegistrationComponent.RegistrationGrid,
                                                        formName:
                                                            "SourceDocument",
                                                        disabled: formDisabled,
                                                        label: "Add Source Document",
                                                        className:
                                                            "source-documents-source-documents",
                                                        minRows: 0,
                                                        columnStyles: [
                                                            {
                                                                width: undefined,
                                                                minWidth:
                                                                    "200px",
                                                            },
                                                            {
                                                                width: "23%",
                                                                minWidth:
                                                                    "150px",
                                                            },
                                                            {
                                                                width: "20%",
                                                                minWidth:
                                                                    "150px",
                                                            },
                                                            {
                                                                width: "125px",
                                                            },
                                                        ],
                                                        removeConfig:
                                                            GridRemove.All,
                                                        addRow: (gridComponent, _index, _array) => {
                                                            const state: Dtos.SourceDocument =
                                                                Object.assign({
                                                                    ...gridComponent.initialState,
                                                                });
                                                            state.subRecordId =
                                                                DocumentType.MedicalIndemnity;
                                                            return state;
                                                        },
                                                        components: {
                                                            name: {
                                                                type: RegistrationComponent.RegistrationControl,
                                                                inputType:
                                                                    TextFormInput,
                                                                inputDisabled:
                                                                    formDisabled,
                                                                inputLabel:
                                                                    getFormPropertyLabel(
                                                                        "CollectionInstance",
                                                                        "FileName",
                                                                        formProperties
                                                                    ),
                                                                inputProps: {
                                                                    feedbackIcon:
                                                                        FontAwesomeIcons
                                                                            .Solid
                                                                            .BAN,
                                                                },
                                                                validators: {
                                                                    required:
                                                                        requiredText,
                                                                },
                                                                errors: {
                                                                    required:
                                                                        "File name is required.",
                                                                },
                                                                errorComponent:
                                                                    ValidationMessage,
                                                            },
                                                            fileInformation: {
                                                                type: RegistrationComponent.RegistrationControl,
                                                                inputType:
                                                                    FileUploadFormInput,
                                                                inputDisabled:
                                                                    formDisabled,
                                                                inputLabel:
                                                                    getFormPropertyLabel(
                                                                        "CollectionInstance",
                                                                        "Upload",
                                                                        formProperties
                                                                    ),
                                                                changeAction: (
                                                                    model,
                                                                    value,
                                                                    form,
                                                                    parentModel
                                                                ) => {
                                                                    changeForm(
                                                                        model,
                                                                        value
                                                                    );
                                                                    const inputValue: Dtos.TemporaryFileInformation =
                                                                        value;
                                                                    const sourceDocument: Dtos.SourceDocument =
                                                                        form;

                                                                    if (
                                                                        sourceDocument.fileInformation &&
                                                                        inputValue &&
                                                                        sourceDocument
                                                                            .fileInformation
                                                                            .state !=
                                                                            inputValue.state &&
                                                                        inputValue.state ==
                                                                            Dtos
                                                                                .FileState
                                                                                .Success &&
                                                                        !sourceDocument.name
                                                                    ) {
                                                                        changeForm(
                                                                            reduxFormName +
                                                                                parentModel +
                                                                                ".name",
                                                                            inputValue.temporaryFile.name.substr(
                                                                                0,
                                                                                inputValue.temporaryFile.name.lastIndexOf(
                                                                                    inputValue
                                                                                        .temporaryFile
                                                                                        .extension
                                                                                )
                                                                            )
                                                                        );
                                                                    }
                                                                },
                                                                inputProps: {
                                                                    render: SOURCE_DOCUMENT_UPLOAD_VIEW,
                                                                },
                                                                validators: {
                                                                    required:
                                                                        requiredSourceDocument,
                                                                },
                                                                errors: {
                                                                    required:
                                                                        "File must be uploaded.",
                                                                },
                                                                errorComponent:
                                                                    ValidationMessage,
                                                            },
                                                            fileConfiguration: {
                                                                type: RegistrationComponent.RegistrationGridElement,
                                                                label: " ",
                                                                render: SOURCE_DOCUMENT_FILE_CONFIGURATION,
                                                            },
                                                        },
                                                        initialState: {
                                                            ...initialSourceDocumentState,
                                                        },
                                                    },
                                                },
                                                keyReplace: "sourceDocuments",
                                                onRemove: (model: string) => {
                                                    if (
                                                        AuthenticationHelper.hasPermission(
                                                            permissions,
                                                            Dtos.Permission
                                                                .TrainingCertificationsUpdate
                                                        )
                                                    ) {
                                                        changeForm(
                                                            model + "active",
                                                            false
                                                        );
                                                    }
                                                    return true; // this was handled here
                                                },
                                                filterRow: (
                                                    data: Dtos.SourceDocument
                                                ) => {
                                                    return (
                                                        !data.isPersonnelItem &&
                                                        data.active &&
                                                        data.subRecordId ==
                                                            DocumentType.MedicalIndemnity
                                                    );
                                                },
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            bctApprovalGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>BCT Approval for Site PI</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "personnel",
                                        {
                                            sitePiApplicationDateApproved: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType:
                                                    DatePickerFormInputFabric,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-2",
                                                fieldClassName:
                                                    "col-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "personnel",
                                        {
                                            sitePiApplicationApprovedDocument: {
                                                size: 1,
                                                type: RegistrationComponent.RegistrationSourceDocuments,
                                                label: "Application Form",
                                                disabled: formDisabled,
                                                components: {
                                                    sourceDocuments: {
                                                        type: RegistrationComponent.RegistrationGrid,
                                                        formName:
                                                            "SourceDocument",
                                                        disabled: formDisabled,
                                                        label: "Add Source Document",
                                                        className:
                                                            "source-documents-source-documents",
                                                        minRows: 0,
                                                        columnStyles: [
                                                            {
                                                                width: undefined,
                                                                minWidth:
                                                                    "200px",
                                                            },
                                                            {
                                                                width: "23%",
                                                                minWidth:
                                                                    "150px",
                                                            },
                                                            {
                                                                width: "20%",
                                                                minWidth:
                                                                    "150px",
                                                            },
                                                            {
                                                                width: "125px",
                                                            },
                                                        ],
                                                        removeConfig:
                                                            GridRemove.All,
                                                        addRow: (gridComponent, _index, _array) => {
                                                            const state: Dtos.SourceDocument =
                                                                Object.assign({
                                                                    ...gridComponent.initialState,
                                                                });
                                                            state.subRecordId =
                                                                DocumentType.SitePiApproval;
                                                            return state;
                                                        },
                                                        components: {
                                                            name: {
                                                                type: RegistrationComponent.RegistrationControl,
                                                                inputType:
                                                                    TextFormInput,
                                                                inputDisabled:
                                                                    formDisabled,
                                                                inputLabel:
                                                                    getFormPropertyLabel(
                                                                        "CollectionInstance",
                                                                        "FileName",
                                                                        formProperties
                                                                    ),
                                                                inputProps: {
                                                                    feedbackIcon:
                                                                        FontAwesomeIcons
                                                                            .Solid
                                                                            .BAN,
                                                                },
                                                                validators: {
                                                                    required:
                                                                        requiredText,
                                                                },
                                                                errors: {
                                                                    required:
                                                                        "File name is required.",
                                                                },
                                                                errorComponent:
                                                                    ValidationMessage,
                                                            },
                                                            fileInformation: {
                                                                type: RegistrationComponent.RegistrationControl,
                                                                inputType:
                                                                    FileUploadFormInput,
                                                                inputDisabled:
                                                                    formDisabled,
                                                                inputLabel:
                                                                    getFormPropertyLabel(
                                                                        "CollectionInstance",
                                                                        "Upload",
                                                                        formProperties
                                                                    ),
                                                                changeAction: (
                                                                    model,
                                                                    value,
                                                                    form,
                                                                    parentModel
                                                                ) => {
                                                                    changeForm(
                                                                        model,
                                                                        value
                                                                    );
                                                                    const inputValue: Dtos.TemporaryFileInformation =
                                                                        value;
                                                                    const sourceDocument: Dtos.SourceDocument =
                                                                        form;

                                                                    if (
                                                                        sourceDocument.fileInformation &&
                                                                        inputValue &&
                                                                        sourceDocument
                                                                            .fileInformation
                                                                            .state !=
                                                                            inputValue.state &&
                                                                        inputValue.state ==
                                                                            Dtos
                                                                                .FileState
                                                                                .Success &&
                                                                        !sourceDocument.name
                                                                    ) {
                                                                        changeForm(
                                                                            reduxFormName +
                                                                                parentModel +
                                                                                ".name",
                                                                            inputValue.temporaryFile.name.substr(
                                                                                0,
                                                                                inputValue.temporaryFile.name.lastIndexOf(
                                                                                    inputValue
                                                                                        .temporaryFile
                                                                                        .extension
                                                                                )
                                                                            )
                                                                        );
                                                                    }
                                                                },
                                                                inputProps: {
                                                                    render: SOURCE_DOCUMENT_UPLOAD_VIEW,
                                                                },
                                                                validators: {
                                                                    required:
                                                                        requiredSourceDocument,
                                                                },
                                                                errors: {
                                                                    required:
                                                                        "File must be uploaded.",
                                                                },
                                                                errorComponent:
                                                                    ValidationMessage,
                                                            },
                                                            fileConfiguration: {
                                                                type: RegistrationComponent.RegistrationGridElement,
                                                                label: " ",
                                                                render: SOURCE_DOCUMENT_FILE_CONFIGURATION,
                                                            },
                                                        },
                                                        initialState: {
                                                            ...initialSourceDocumentState,
                                                        },
                                                    },
                                                },
                                                keyReplace: "sourceDocuments",
                                                onRemove: (model: string) => {
                                                    if (
                                                        AuthenticationHelper.hasPermission(
                                                            permissions,
                                                            Dtos.Permission
                                                                .TrainingCertificationsUpdate
                                                        )
                                                    ) {
                                                        changeForm(
                                                            model + "active",
                                                            false
                                                        );
                                                    }
                                                    return true; // this was handled here
                                                },
                                                filterRow: (
                                                    data: Dtos.SourceDocument
                                                ) => {
                                                    return (
                                                        !data.isPersonnelItem &&
                                                        data.active &&
                                                        data.subRecordId ==
                                                            DocumentType.SitePiApproval
                                                    );
                                                },
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
        };

        return (
            <>
                <div className="row">
                    <div className={"col-auto"}>
                        <h1>Training</h1>
                    </div>
                    <div
                        className="col d-flex justify-content-end align-items-stretch"
                        style={{ height: "38px" }}
                    >
                        <button
                            onClick={() => setIsOpen(true)}
                            className="btn btn-primary mr-2"
                        >
                            Add
                        </button>
                    </div>
                </div>
                {renderTrainingTable}
                <hr style={{ marginBottom: "20px", marginTop: "30px" }} />
                <Form
                    model={reduxFormName}
                    onSubmit={(val, _event) => handleOnSubmit(val)}
                    onSubmitFailed={(val) => handleOnSubmitFailed(val)}
                >
                    {renderFormControls(
                        form,
                        "personnel",
                        formComponents,
                        lookups,
                        validationFailures,
                        formProperties,
                        changeForm,
                        undefined,
                        undefined,
                        undefined,
                        form
                    )}
                    <div className="mt-4 mb-4 text-right">
                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                changeForm(
                                    reduxFormName + ".saveAndReturn",
                                    false
                                );
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit
                        </button>

                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                changeForm(
                                    reduxFormName + ".saveAndReturn",
                                    true
                                );
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit And Return
                        </button>
                        <button
                            onClick={onCancel}
                            className="btn btn-primary mr-2"
                        >
                            Cancel
                        </button>
                    </div>
                </Form>
            </>
        );
    }, [
        handleOnSubmit,
        handleOnSubmitFailed,
        form,
        lookups,
        validationFailures,
        changeForm,
        onCancel,
        permissions,
        savingPersonnel,
        formState,
        renderTrainingTable,
        isOpen,
        setIsOpen,
        personnelTrainingId,
    ]);

    return (
        <RestrictedLayout
            permission={Dtos.Permission.TrainingCertificationsView}
            loading={loadingPersonnel}
        >
            {renderContent}
            <PersonnelTrainingFormModal
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                personnelTrainingId={personnelTrainingId}
            />
        </RestrictedLayout>
    );
};

const mapStateToProps = (
    state: ITmdState
): Partial<PersonnelTrainingCertificationPageProps> => {
    let personnel: Dtos.Personnel | undefined = !(
        state.personnel.formData instanceof Array
    )
        ? state.personnel.formData
        : undefined;
    let personnelTraining: Dtos.PersonnelTraining[] | undefined = (
        state.personnelTraining.formData instanceof Array
    )
        ? state.personnelTraining.formData
        : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        personnel: personnel!,
        loadingPersonnel:
            state.personnel.loadState &&
            state.personnel.loadState.status == RequestState.Pending,
        loadPersonnelSuccess:
            state.personnel.loadState &&
            state.personnel.loadState.status == RequestState.Success,
        loadPersonnelFailure:
            state.personnel.loadState &&
            state.personnel.loadState.status == RequestState.Failure,
        loadPersonnelErrorCode: state.personnel.loadState.errorCode,
        savingPersonnel:
            state.personnel.saveState &&
            state.personnel.saveState.status == RequestState.Pending,
        savePersonnelSuccess:
            state.personnel.saveState &&
            state.personnel.saveState.status == RequestState.Success,
        savePersonnelFailure:
            state.personnel.saveState &&
            state.personnel.saveState.status == RequestState.Failure,
        validatingPersonnel:
            state.personnel.validateState &&
            state.personnel.validateState.status == RequestState.Pending,
        personnelTraining: personnelTraining!,
        loadingPersonnelTraining:
            state.personnelTraining.loadState &&
            state.personnelTraining.loadState.status == RequestState.Pending,
        loadPersonnelTrainingSuccess:
            state.personnelTraining.loadState &&
            state.personnelTraining.loadState.status == RequestState.Success,
        loadPersonnelTrainingFailure:
            state.personnelTraining.loadState &&
            state.personnelTraining.loadState.status == RequestState.Failure,
        loadPersonnelTrainingErrorCode: state.personnelTraining.loadState.errorCode,
        user: state.user.data,
        permissions: permissions,
        lookups: state.personnel.lookups,
        form: state.reduxForms.personnel,
        formState: state.personnel.formState,
        formProperties: state.personnel.formProperties,
        reduxFormState: state.reduxForms.formState.personnel,
        validationFailures: personnel
            ? state.personnel.validationFailures
            : undefined,
        pageSize: state.pagingPage.pageSize,
    };
};

const mapDispatchToProps = (
    dispatch
): Partial<PersonnelTrainingCertificationPageProps> => {
    return {
        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),
        loadPersonnel: bindActionCreators(PersonnelActions.LoadPersonnelById, dispatch),
        clearPersonnel: bindActionCreators(PersonnelActions.Clear, dispatch),
        savePersonnel: bindActionCreators(PersonnelActions.SavePersonnel, dispatch),
        validatePersonnel: bindActionCreators(PersonnelActions.ValidatePersonnel, dispatch),
        loadPersonnelTraining: bindActionCreators(PersonnelTrainingActions.LoadPersonnelTrainingByPersonnelId, dispatch),
        clearPersonnelTraining: bindActionCreators(PersonnelTrainingActions.Clear, dispatch),
        setBreadcrumbs: bindActionCreators(NavigationActions.SetBreadcrumbs, dispatch),
        setDrawerItems: bindActionCreators(NavigationActions.SetDrawerItems, dispatch),
        setPageSize: bindActionCreators(PagingActions.PageSizeChanged, dispatch)
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PersonnelTrainingCertificationPage);
